import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../authentication/AuthContext';

function PaymentSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const { updateUserAttributes } = useAuth();
  
  useEffect(() => {
    const handlePaymentSuccess = async () => {
      try {
        // Get query parameters
        const params = new URLSearchParams(location.search);
        const sessionId = params.get('session_id');
        
        if (sessionId) {
          console.log('Payment successful with session ID:', sessionId);
          
          // Refresh user attributes to reflect updated subscription status
          await updateUserAttributes();
          
          // Redirect to account page after a short delay
          setTimeout(() => {
            navigate('/account', { 
              state: { 
                message: 'Payment processed successfully. Your account has been updated.' 
              } 
            });
          }, 1500);
        } else {
          // If there's no session ID, just go to account page
          navigate('/account');
        }
      } catch (error) {
        // console.error('Error handling successful payment:', error);
        navigate('/account', { 
          state: { 
            message: 'Payment was successful, but there was an issue updating your account. Please refresh the page.' 
          } 
        });
      }
    };
    
    handlePaymentSuccess();
  }, [navigate, location, updateUserAttributes]);
  
  return (
    <div className="payment-success">
      <h2>Payment Successful!</h2>
      <p>Your payment has been processed successfully.</p>
      <p>Redirecting you to your account page...</p>
    </div>
  );
}

export default PaymentSuccess;